import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { GET_COIN_RACE_DETAILS_QUERY_KEY } from './use-query-coin-race-details';
import { GET_COIN_RACES_QUERY_KEY } from './use-query-coin-races';

const LEAVE_COIN_RACE_URL = '/coin_races';

interface LeaveCoinRaceRequest {
  id: string;
}

export const useMutationLeaveCoinRace = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: LeaveCoinRaceRequest) =>
      request({
        method: 'delete',
        url: getUrlToBackendApi(`${LEAVE_COIN_RACE_URL}/${id}`).href
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_COIN_RACES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_COIN_RACE_DETAILS_QUERY_KEY] });
    }
  });
};
